module.exports = __webpack_public_path__ + "img/logo-title.b673d7e0.svg";